import {Fragment, h} from 'preact';
import DeviceDetailsInfo from './DeviceDetailsInfo';

export default function BlockItemInnerToggle({item, method, toggleHandler}){
    return (
        <div data-id={method + '-' + item.serial} className="block-item account-details__block">
            <div onClick={() => toggleHandler(method + '-' + item.serial)} className="row block-item__head">
                <div className={'col col-12 col-lg-6'}>
                    Прибор учета: {item.serial}
                </div>
                <div className="col col-12 col-lg-6">
                </div>
            </div>
            <div className="block-item__data account-details__data">
                <DeviceDetailsInfo data={item.data}/>
            </div>
        </div>
    )
}
